function overlayGalleryOn() {
    //$('body').addClass('no-scroll');
    document.getElementById("overlay-gallery").style.display = "block";

    $('.tab-gallery-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.tab-gallery-slider-nav',
        infinite: true,
    });

    $('.tab-gallery-slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.tab-gallery-slider',
        dots: false,
        focusOnSelect: true,
        arrows: true,
        infinite: true,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">P</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">N</button>',
        responsive:[
            {
                breakpoint: 991,
                settings:{
                    slidesToShow: 2
                }
            }
        ]
    });
}


//largoje galerine
function overlayGalleryOff() {
    document.getElementById("overlay-gallery").style.display = "none";
    //$('body').removeClass('no-scroll');
}

//galeria 2
function overlayGalleryModOn() {
    //$('body').addClass('no-scroll');
    document.getElementById("overlay-gallery-mod").style.display = "block";

    $('.tab-gallery-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.tab-gallery-slider-nav',
        infinite: true,
    });

    $('.tab-gallery-slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.tab-gallery-slider',
        dots: false,
        focusOnSelect: true,
        arrows: true,
        infinite: true,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">P</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">N</button>',
        responsive:[
            {
                breakpoint: 991,
                settings:{
                    slidesToShow: 2
                }
            }
        ]
    });
}


//largoje galerine 2
function overlayGalleryModOff() {
    document.getElementById("overlay-gallery-mod").style.display = "none";
    //$('body').removeClass('no-scroll');
}

//VIDEO
function overlayGalleryVideoOn() {
   //$('body').addClass('no-scroll');
    document.getElementById("overlay-gallery-video").style.display = "block";

    $('.tab-gallery-video-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.tab-gallery-video-slider-nav',
        infinite: true,
    });

    $('.tab-gallery-video-slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.tab-gallery-video-slider',
        dots: true,
        focusOnSelect: true,
        arrows: true,
        infinite: true,
        prevArrow: '<button class="slick-prev-v" aria-label="Previous" type="button"></button>',
        nextArrow: '<button class="slick-next-v" aria-label="Next" type="button"></button>',
        responsive:[
            {
                breakpoint: 991,
                settings:{
                    slidesToShow: 2
                }
            }
        ]
    });
}

//largoje galerine video
function overlayGalleryVideoOff() {
    document.getElementById("overlay-gallery-video").style.display = "none";
    //$('body').removeClass('no-scroll');
    $('#videoContainer')[0].pause();
}



function overlayGalleryVideoProductOn() {
    //$('body').addClass('no-scroll');
    document.getElementById("overlay-gallery-video-product").style.display = "block";
    document.getElementById("overlay-gallery-video-product").style.overflow = "hidden";

    $('#videoContainerProduct')[0].play();


}

//largoje galerine video
function overlayGalleryVideoProductOff() {
    document.getElementById("overlay-gallery-video-product").style.display = "none";
   // $('body').removeClass('no-scroll');
    $('#videoContainerProduct')[0].pause();
}